import React, {Component, Fragment} from 'react'
import {Breadcrumb, Card, Row, Tabs} from 'antd'
import style from '../style.css'
import List from './List'
import StatementModal from './StatementModal'
import TransactionsCont from './Transactions/TransactionsCont'
import IconText from '../../../elements/IconText'
import {withRouter} from 'react-router-dom'
import {get} from 'lodash'

const {TabPane} = Tabs

class Statements extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Finance</Breadcrumb.Item>
              <Breadcrumb.Item>Statements</Breadcrumb.Item>
            </Breadcrumb>
            <h2 className={style.title}>Bank Statements</h2>
            <p className={style.paragraph}>View and list banking statements.</p>
          </Row>
        </Card>
        <StatementModal key={'statement-modal'} {...this.props} />
        <Card className={style.contentCard}>
          <Tabs
            defaultActiveKey={get(this.props, 'location.hash') || '#statements'}
            onChange={key => this.props.history.push(key)}>
            <TabPane
              tab={<IconText text={'Statements'} type={'book'} />}
              key="#statements">
              <List {...this.props} />
            </TabPane>
            <TabPane
              tab={<IconText text={'Transactions'} type={'file-text'} />}
              key="#transactions">
              <TransactionsCont />
            </TabPane>
          </Tabs>
        </Card>
      </Fragment>
    )
  }
}

Statements.propTypes = {}
Statements.defaultProps = {}

export default withRouter(Statements)
